import "./TablaUsuariosEmpleados.css";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus, faFileImport } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { DarkModeContext } from "../../context/DarkModeContext";
import { getToken } from "../../utils/auth";
import ModalRubroAdmin from "./ModalRubroAdmin";

const TablaRubrosAdmin = () => {
  const { darkMode } = useContext(DarkModeContext);
  const [rubros, setRubros] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [seleccionado, setSeleccionado] = useState(null);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [importando, setImportando] = useState(false);
  const archivoRef = useRef(null);

  const cargarRubros = async () => {
    const response = await fetch("/api/Rubro/lista");
    if (!response.ok) throw new Error("No se pudo cargar el catálogo de rubros.");
    const data = await response.json();
    setRubros(Array.isArray(data) ? data : []);
  };

  useEffect(() => { cargarRubros().catch((error) => console.error(error)); }, []);

  const filtrados = useMemo(() => {
    const termino = filtro.trim().toLowerCase();
    if (!termino) return rubros;
    return rubros.filter((rubro) =>
      `${rubro.codigoActividad || ""} ${rubro.nomRubro || ""} ${rubro.descripcion || ""}`.toLowerCase().includes(termino)
    );
  }, [rubros, filtro]);

  const importar = async (event) => {
    const archivo = event.target.files?.[0];
    event.target.value = "";
    if (!archivo) return;

    const formData = new FormData();
    formData.append("Token", getToken() || "");
    formData.append("Archivo", archivo);
    setImportando(true);
    try {
      const response = await fetch("/api/Rubro/importar-f883", { method: "POST", body: formData });
      const text = await response.text();
      if (!response.ok) throw new Error(text || "No se pudo importar el archivo.");
      const resultado = JSON.parse(text);
      await cargarRubros();
      Swal.fire("Importación completa", `${resultado.total} filas procesadas: ${resultado.creados} nuevas, ${resultado.actualizados} actualizadas y ${resultado.sinCambios} sin cambios.`, "success");
    } catch (error) {
      Swal.fire("Error", error.message || "No se pudo importar el archivo.", "error");
    } finally {
      setImportando(false);
    }
  };

  const eliminar = async (rubro) => {
    const confirmacion = await Swal.fire({
      title: "Eliminar rubro", text: `${rubro.codigoActividad} - ${rubro.nomRubro}`,
      icon: "warning", showCancelButton: true, confirmButtonText: "Eliminar", cancelButtonText: "Cancelar",
    });
    if (!confirmacion.isConfirmed) return;

    const response = await fetch("/api/Rubro/eliminar", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ Token: getToken(), Id: rubro.id }),
    });
    const text = await response.text();
    if (!response.ok) return Swal.fire("Error", text || "No se pudo eliminar el rubro.", "error");
    await cargarRubros();
    Swal.fire("Eliminado", "El rubro se eliminó correctamente.", "success");
  };

  return (
    <div className={darkMode ? "container bg-tabla-usuarios-liquidaciones-dark" : "container bg-tabla-usuarios-liquidaciones"}>
      <section className="container mt-3 mb-3">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 py-3">
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <h6 className="m-0 fs-18-a-16">Rubros ({rubros.length})</h6>
            <Form.Control className={darkMode ? "text-white label-buscador-dark border-0" : "label-buscador border-0"}
              style={{ maxWidth: 360 }} placeholder="Buscar por código, rubro o descripción" value={filtro}
              onChange={(e) => setFiltro(e.target.value)} />
          </div>
          <div className="d-flex gap-2">
            <input ref={archivoRef} type="file" accept=".txt,text/plain" hidden onChange={importar} />
            <Button variant="outline-secondary" disabled={importando} onClick={() => archivoRef.current?.click()}>
              {importando ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={faFileImport} />} <span className="ms-2">Importar F.883</span>
            </Button>
            <Button className="border-0 btn-modal-nuevo-usuario-editar" onClick={() => { setSeleccionado(null); setModalAbierto(true); }}>
              <FontAwesomeIcon icon={faCirclePlus} /><span className="ms-2">Nuevo</span>
            </Button>
          </div>
        </div>
      </section>
      <div className="table-responsive py-3 px-4">
        <table className="table table-borderless responsive striped hover">
          <thead><tr className="text-center tabla-thead">
            <th>Código F.883</th><th>Rubro</th><th>Descripción</th><th>Acciones</th>
          </tr></thead>
          <tbody className="text-center">
            {filtrados.map((rubro) => (
              <tr key={rubro.id} className={darkMode ? "tabla-borde-bottom text-white" : "tabla-borde-bottom text-dark"}>
                <td className="pt-4">{rubro.codigoActividad || "-"}</td><td className="pt-4 text-start">{rubro.nomRubro}</td>
                <td className="pt-4 text-start">{rubro.descripcion}</td>
                <td className="pt-3 text-nowrap">
                  <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => { setSeleccionado(rubro); setModalAbierto(true); }}>Editar</button>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => eliminar(rubro)}>Eliminar</button>
                </td>
              </tr>
            ))}
            {!filtrados.length && <tr><td colSpan="4">No se encontraron rubros.</td></tr>}
          </tbody>
        </table>
      </div>
      <ModalRubroAdmin show={modalAbierto} onHide={() => setModalAbierto(false)} rubro={seleccionado} onSuccess={cargarRubros} />
    </div>
  );
};

export default TablaRubrosAdmin;
